export enum ESegmentTitle {
    easy = 'Легкие',
    medium = 'Средние',
    hard = 'Тяжелые',
    all = 'Всего',
}
